import React ,{useEffect}from "react";
import { PrivacyHeader } from "../components";

export function PrivacyHeaderContainer({ children }) {

useEffect(()=>{window.scrollTo(0,0)},[])

  return (
    <PrivacyHeader>
      <PrivacyHeader.Frame>
        <PrivacyHeader.Logo href='/' />
      </PrivacyHeader.Frame>
    </PrivacyHeader>
  );
}